import { render, staticRenderFns } from "./PrepaidActivationIncentive.vue?vue&type=template&id=40db9912&"
import script from "./PrepaidActivationIncentive.vue?vue&type=script&lang=js&"
export * from "./PrepaidActivationIncentive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports